import React from 'react';
import AddProperty from '../form/AddProperty'
import DataProvider from '../form/DataProvider';
import { useParams } from 'react-router-dom'
import EditProperty from '../form/EditProperty'

export default function PropertyPage() {
  let {lid} = useParams()

  return (
    <>
      <DataProvider>
        <div className='container'>
          {lid === "add" ?
            <AddProperty />
            :
            <EditProperty />
          }
        </div>
      </DataProvider>

    </>
  );
};


